import { RouteConfig } from "vue-router"
import { isAuthenticated, isClinicalAdmin } from "@/routers/router-guardians"

const dashboardRoutes: RouteConfig[] = [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/layouts/dashboard-layout/DashboardLayout.vue"),
    children: [
      {
        path: "/dashboard/profile",
        name: "profile",
        component: () => import("@/pages/Settings.vue"),
        beforeEnter(to, from, next) {
          isAuthenticated(to, from, next)
        }
      },
      {
        path: "/dashboard/subordinates",
        name: "subordinates",
        component: () => import("@/pages/Subordinates.vue"),
        beforeEnter(to, from, next) {
          isAuthenticated(to, from, next)
        }
      },
      {
        path: "/dashboard/subordinates/:providerId/appointments",
        name: "subordinates_appointments",
        component: () => import("@/pages/SubordinateAppointments.vue"),
        props: true,
        beforeEnter(to, from, next) {
          isAuthenticated(to, from, next)
        }
      },
      {
        path: "/dashboard/member-profiles",
        name: "member-profiles",
        component: () => import("@/modules/members/pages/member-profiles/MemberProfilesPage.vue"),
        beforeEnter(to, from, next) {
          isAuthenticated(to, from, next)
        }
      },
      {
        path: "appointments/:appointmentId/member/:memberId/telemedicine",
        name: "twilio_telemedicine",
        props: true,
        component: () => import("@/pages/Telemedicine.vue"),
        beforeEnter(to, from, next) {
          isAuthenticated(to, from, next)
        }
      },
      {
        path: "/dashboard/e-lab-ordering/encounters/:encounterId/needsFollowup/:needsLabDrawFollowUp",
        name: "e-lab-ordering",
        component: () => import("@/pages/ELabOrdering.vue"),
        props: (route) => ({
          encounterId: route.params.encounterId,
          memberId: route.params.memberId,
          occHealthLabOrderRequestId: route.params.occHealthLabOrderRequestId,
          labPartner: route.params.labPartner
        }),
        beforeEnter(to, from, next) {
          isAuthenticated(to, from, next)
        }
      },
      {
        path: "/dashboard/labs",
        name: "lab-orders",
        component: () => import("@/pages/labs/Labs.vue"),
        beforeEnter(to, from, next) {
          isClinicalAdmin(to, from, next)
        }
      },
      {
        path: "/dashboard/medical-charts",
        name: "medical-charts",
        component: () => import("@/pages/dynamic-medical-charts/DynamicMedicalCharts.vue"),
        beforeEnter(to, from, next) {
          isAuthenticated(to, from, next)
        }
      },
      {
        path: "/patient-member-layout",
        name: "patient-member-layout",
        component: () => import("@/layouts/patient-layout/PatientLayout.vue"),
        props: (route) => ({ memberId: route.params.memberId }),
        children: [
          {
            path: "/dashboard/member-profiles/:memberId",
            name: "member-profile-details",
            component: () => import("@/modules/members/pages/member-profile-details/MemberProfileDetailsPage.vue"),
            props: (route) => ({ memberId: route.params.memberId }),
            beforeEnter(to, from, next) {
              isAuthenticated(to, from, next)
            }
          }
        ]
      }
    ]
  },
  {
    // TODO: Warning: There is a Backend Dependency on this route: see HG_CREATE_LAB_ORDER_CALLBACK_URI
    path: "/e-lab-ordering-confirmation",
    name: "e-lab-ordering-confirmation",
    component: () => import("@/pages/ELabOrderingConfirmation.vue"),
    beforeEnter(to, from, next) {
      isAuthenticated(to, from, next)
    }
  }
]

export default dashboardRoutes
